import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { formatDollars } from '../../../../utils/formatting';
const premiumContentAdapter = (props)=>{
    var _deviation_pcp, _deviation_pcp1;
    const deviation = props.deviation;
    var _deviation_pcp_downloadPrice;
    const price = (_deviation_pcp_downloadPrice = (_deviation_pcp = deviation.pcp) === null || _deviation_pcp === void 0 ? void 0 : _deviation_pcp.downloadPrice) !== null && _deviation_pcp_downloadPrice !== void 0 ? _deviation_pcp_downloadPrice : '???';
    const dollarsCost = ((_deviation_pcp1 = deviation.pcp) === null || _deviation_pcp1 === void 0 ? void 0 : _deviation_pcp1.downloadDollarPrice) !== undefined ? formatDollars(deviation.pcp.downloadDollarPrice) : '???';
    return _object_spread_props(_object_spread({}, props), {
        price,
        dollarsCost,
        priceLabel: 'shop.thumb.points'
    });
};
export default premiumContentAdapter;
